import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MainComponent} from './components/main/main.component';
import {QualityComponent} from './components/quality/quality.component';
import {ContactsComponent} from './components/contacts/contacts.component';
import {IndependenceComponent} from './components/independence/independence.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent
  },
  {
    path: 'quality',
    component: QualityComponent
  },
  {
    path: 'independence',
    component: IndependenceComponent
  },
  {
    path: 'contacts',
    component: ContactsComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
